import React from 'react';
import HtmlEntityTextComponent from '../components/html-entity-text/html-entity-text-component';
import Link from '../components/link/link';
import { ComponentTypeNames } from '../schema';
import { InternalPageReference } from '../schema/datocms';
import faqSlug from './faq-slug';

export function buildQuestionListItem(index: number, groupName: string, question: string): JSX.Element {
    const faqUrl: string = faqSlug.buildFaqUrlSlug(groupName, question);
    const internalPageRef: InternalPageReference = {
        __typename: ComponentTypeNames.PAGE,
        slug: faqUrl
    };

    return <li key={index}><Link className="underline font-bold" internalPageReference={internalPageRef}>
        { <HtmlEntityTextComponent text={question} /> || question }
    </Link></li>;
}
